<ul *ngIf="Paginas.length">
    <li *ngFor="let pagina of Paginas; let i = index" [ngClass]="{'active': i < Actual}">
        <span>{{ pagina.short_name}}</span>
    </li>
</ul>